// extracted by mini-css-extract-plugin
module.exports = {"postThumbnail":"PostMedia_postThumbnail__3XhR5"};